import { SVG_NS, XLINK_NS, XMLNS_NS } from './consts';

export function getMeasurer() {
  const svg = document.getElementById('measurer');
  if (svg) {
    return svg;
  }

  const svgElement = document.createElementNS(SVG_NS, 'svg');
  svgElement.setAttributeNS(XMLNS_NS, 'xmlns:xlink', XLINK_NS);
  svgElement.setAttributeNS(XMLNS_NS, 'xmlns', SVG_NS);
  svgElement.setAttribute('version', '1.2');
  svgElement.setAttribute('width', '100');
  svgElement.setAttribute('height', '100');
  svgElement.setAttribute('viewBox', `0 0 100 100`);
  svgElement.setAttribute('id', 'measurer');

  document.body.appendChild(svgElement);
  return svgElement;
}
